import { useLanguage } from '../../shell/language-context';
import { Cover } from './hx-cover';

/** Tiles per drifting row; the row is doubled so the -50% keyframe loops seamlessly. */
const TILES = 12;

function Row({ photos, categories, reverse }: { photos: string[]; categories: (string | undefined)[]; reverse?: boolean }) {
  const half = Array.from({ length: TILES }, (_, i) => ({ src: photos.length ? photos[(i + (reverse ? 5 : 0)) % photos.length] : undefined, cat: categories[i % Math.max(1, categories.length)], i }));
  return (
    <div className="mwrap" aria-hidden="true">
      <div className={reverse ? 'mrow r' : 'mrow'}>
        {[...half, ...half].map((x, n) => (
          <Cover key={n} src={x.src} categoryId={x.cat} id={`plan-${reverse ? 'b' : 'a'}-${x.i}`} />
        ))}
      </div>
    </div>
  );
}

// "You will find your next plan here." (design `.plan`): the headline between two rows of
// rounded photo tiles drifting in opposite directions. The photos are the covers of the
// listings the home page already holds; with none, the design's illustrated scenes fill the
// tiles. Decorative, so the rows are hidden from screen readers.
export function HxPlan({ photos, categories }: { photos: string[]; categories: (string | undefined)[] }) {
  const { t } = useLanguage();
  return (
    <section className="plan">
      <Row photos={photos} categories={categories} />
      <div className="in">
        <h2 className="rv">
          {t('hx.plan.title_a')}{' '}
          <br />
          {t('hx.plan.title_b')}
        </h2>
        <p className="rv">{t('hx.plan.sub')}</p>
      </div>
      <Row photos={photos} categories={categories} reverse />
    </section>
  );
}
